import { Modal, Spin, Table, Tag } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { FilePdfOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import moment from "moment";
import { ButtonItem } from "../../../../Components/Items";
import EnviarCorreoApartarVenta from "../ApartarInsumosVenta/EnviarCorreoApartarVenta/EnviarCorreoApartarVenta";

class ApartadosVenta extends Component {
  state = { loading: false, apartados: [], insumos: [], usuarios: [] };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.consultarTodo();
    }
  }

  consultarTodo() {
    this.setState({ loading: true });
    axios
      .post(
        "ventas/apartadosVenta",
        { ventaId: this.props.id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          this.setState({
            apartados: res.data.apartados,
            insumos: res.data.insumos,
            usuarios: res.data.usuarios,
          });
        }
      });
  }

  abrirPdf(apartado) {
    const insumosApartados = apartado.insumos.map((i) => {
      const insumo = this.state.insumos.find(
        (in_) => in_._id.toString() === i.insumoId?.toString(),
      );
      return {
        insumoId: i.insumoId,
        clave: insumo?.clave || insumo?.codigo || "",
        descripcion: insumo?.descripcion || "",
        apartar: i.cantidad,
      };
    });

    this.setState({
      modalCorreoApartado: true,
      insumosApartadosSeleccionados: insumosApartados,
    });
  }
  render() {
    const { apartados, insumos, usuarios } = this.state;

    return (
      <>
        <Modal
          title="Historial de Apartados"
          visible={this.props.visible}
          onCancel={this.props.cerrarApartadosVenta}
          footer={null}
          width={700}
        >
          <Spin spinning={this.state.loading}>
            {apartados.length === 0 ? (
              <p style={{ textAlign: "center", color: "#999" }}>
                Sin historial de apartados
              </p>
            ) : (
              apartados.map((apartado, index) => {
                const usuario = usuarios.find(
                  (u) => u._id.toString() === apartado.usuarioId?.toString(),
                );
                return (
                  <div
                    key={index}
                    style={{
                      marginBottom: 16,
                      borderBottom: "1px solid #f0f0f0",
                      paddingBottom: 12,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: 8,
                      }}
                    >
                      <Tag color="orange">Apartado #{index + 1}</Tag>
                      <span style={{ fontSize: 14, color: "#666" }}>
                        {moment(apartado.fecha).format("DD/MM/YYYY HH:mm")}
                      </span>
                      {usuario && (
                        <span style={{ fontSize: 14, color: "#999" }}>
                          {usuario.nombre} {usuario.apellidoPaterno}
                        </span>
                      )}
                      <ButtonItem
                        size="small"
                        blanco
                        icon={<FilePdfOutlined style={{ color: "red" }} />}
                        onClick={() => this.abrirPdf(apartado)}
                      >
                        Ver PDF
                      </ButtonItem>
                    </div>
                    <Table
                      size="small"
                      pagination={false}
                      dataSource={apartado.insumos.map((i, idx) => {
                        const insumo = insumos.find(
                          (in_) =>
                            in_._id.toString() === i.insumoId?.toString(),
                        );
                        return {
                          key: idx,
                          clave: insumo?.clave || insumo?.codigo || "-",
                          descripcion: insumo?.descripcion || "-",
                          cantidad: i.cantidad,
                        };
                      })}
                      columns={[
                        { title: "Clave", dataIndex: "clave", width: "15%" },
                        { title: "Descripción", dataIndex: "descripcion" },
                        {
                          title: "Cantidad",
                          dataIndex: "cantidad",
                          width: "15%",
                          align: "right",
                        },
                      ]}
                    />
                  </div>
                );
              })
            )}
          </Spin>
        </Modal>
        <EnviarCorreoApartarVenta
          visible={this.state.modalCorreoApartado}
          id={this.props.id}
          insumosApartados={this.state.insumosApartadosSeleccionados}
          cerrarModal={() =>
            this.setState({
              modalCorreoApartado: false,
              insumosApartadosSeleccionados: [],
            })
          }
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ApartadosVenta);
